export default "__VITE_PUBLIC_ASSET__9f54d14b__"